import type { Components, CSSProperties, Theme } from "@mui/material";
import type { DataGridProps } from "@mui/x-data-grid";

declare module "@mui/material/styles" {
	interface Components {
		MuiDataGrid?: {
			defaultProps?: Partial<DataGridProps>;
			styleOverrides?: {
				root?: CSSProperties | ((props: { theme: Theme }) => CSSProperties);
			};
		};
	}
}

export const MuiDataGrid: Components<Theme>["MuiDataGrid"] = {
	defaultProps: {
		disableRowSelectionOnClick: true,
	},
	styleOverrides: {
		root: ({ theme }) => ({
			backgroundColor: theme.palette.background.paper,
			borderColor: theme.palette.divider,
			cursor: "default",
			borderRadius: theme.spacing(2),
			"& .MuiDataGrid-columnHeaders": {
				borderBottom: `1px solid ${theme.palette.divider}`,
				fontSize: "1rem",
				"& div": { backgroundColor: theme.palette.muted.main },
			},
			"& .MuiDataGrid-columnHeader": {
				"&:focus, &:focus-within": { outline: "none" },
			},
			"& .MuiDataGrid-cell": {
				alignItems: "center",
				borderBottom: `1px solid ${theme.palette.muted.dark}`,
				display: "flex",
				lineHeight: "1rem",
				paddingInline: theme.spacing(2),
				"&:focus, &:focus-within": { outline: "none" },
			},
		}),
	},
};
